import BaseResource from './index'
import moment from 'moment'
import CalendarResource from './calendar'
import UserResource from './user'
import { ics } from 'calendar-link'

export default class ReservationResource extends BaseResource {
    static endpoint = '/reservations'
    static related() {
        return {
            user: UserResource,
            calendar: CalendarResource,
        }
    }

    timeFormat = 'h:mm a'
    dateFormat = 'YYYY-MM-DD'

    get dateTime() {
        return new Date(this.get('time'))
    }

    async markAsPaid() {
        this.set('paid', true)
        return await this.save()
    }

    async markAsUnpaid() {
        this.set('paid', false)
        return await this.save()
    }

    async getCostCents() {
        return await this.resolveAttribute('price_cents')
    }

    getTimeContext(gracePeriodMinutes = 0) {
        const currentTime = new Date()
        const thirtyFromNow = new Date(currentTime)
        thirtyFromNow.setMinutes(currentTime.getMinutes() + 30)
        const thirtyFromStart = new Date(this.dateTime)
        thirtyFromStart.setMinutes(this.dateTime.getMinutes() + 30)

        if (gracePeriodMinutes > 0) {
            this.futureDateFrom = new Date(currentTime)
            this.futureDateFrom.setMinutes(currentTime + gracePeriodMinutes)
        } else {
            this.futureDateFrom = this.dateTime
        }

        const isNext = this.dateTime > currentTime && this.dateTime < thirtyFromNow
        const isCurrent = currentTime > this.dateTime && currentTime < thirtyFromStart
        const isFuture = this.dateTime > currentTime

        return {
            isNext,
            isCurrent,
            isFuture,
            currentTime,
        }
    }

    getTimeFormatted() {
        return moment(this.dateTime).format(this.timeFormat)
    }

    getDateFormatted() {
        return moment(this.dateTime).format(this.dateFormat)
    }

    getAddToCalendarLink() {
        return ics({
            title: 'Sim Reservation',
            start: this.dateTime,
            duration: [30, 'minute'],
            location: '785 Oak Grove Rd, Suite R, Concord, CA 94518'
        })
    }

    toHashKey() {
        if(!this.attributes.calendar || !this.attributes.slot) {
            throw new Error('Cannot create hash key for reservation: slot and calendar both required')
        }

        return `${this.attributes.calendar}_${this.attributes.slot}`
    }

    toString() {
        return moment(this.dateTime).format('dddd, MMMM Do \@ h:mm a')
    }
}
